module.exports = __webpack_public_path__ + "images/icons_v2/arrow-left-9bbcbbbe.svg";